import styled from "styled-components";
import { Menu as BaseMenu } from "antd";
import color from "../_style/color";

const MoreIcon = styled.span`
  display: block;
  margin: 2.5px 5px 2.5px 7.5px;
  width: 5px;
  height: 5px;
  border: 1px solid ${color.highgray};
  border-radius: 50px;
  float: none;
  cursor: pointer;
`;

const Menu = styled(BaseMenu)`
  padding: 0px;

  li {
    height: 28px;
    line-height: 28px;
    padding: 0 10px;
    font-size: 14px;
  }

  li:hover {
    background: ${color.whisper};
    color: ${color.primary};
    cursor: pointer;
  }
`;

Menu.MoreIcon = MoreIcon;

export default Menu;
